import axios from 'axios'

var qs = require('qs');
var root=process.env.API_ROOT


//获取列表数据
export const getInforClassListData = (params) => {
  return axios.post(root+'/oa/inforclass/list', qs.stringify(params))
}


//删除行
export const deleteData = (params) => {
  return axios.post(root+'/oa/inforclass/remove',  qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root+'/oa/inforclass/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.classcode) {//修改
    return axios.post(root+'/oa/inforclass/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/oa/inforclass/save',qs.stringify(params))
  }
}

//获取产品类型树
export const getClassTree =(params) => {
  return axios.post(root+'/oa/inforclass/classtree',qs.stringify(params))
}





// WEBPACK FOOTER //
// ./src/api/oa/inforclass.js